import {
  SUPPLIER_PRODUCT_LIST,
  SUPPLIER_PRODUCT_LIST_SUCCESS,
  SUPPLIER_PRODUCT_LIST_FAILURE,
  SUPPLIER_PRODUCT_DATA,
  SUPPLIER_PRODUCT_DATA_SUCCESS,
  SUPPLIER_PRODUCT_DATA_FAILURE,
  SUPPLIER_PRODUCT_SEARCH,
  SUPPLIER_PRODUCT_SEARCH_SUCCESS,
  SUPPLIER_PRODUCT_SEARCH_FAILURE,
  SUPPLIER_PRODUCT_CREATE,
  SUPPLIER_PRODUCT_CREATE_SUCCESS,
  SUPPLIER_PRODUCT_CREATE_FAILURE,
  SUPPLIER_PRODUCT_UPDATE,
  SUPPLIER_PRODUCT_UPDATE_SUCCESS,
  SUPPLIER_PRODUCT_UPDATE_FAILURE,
  SUPPLIER_PRODUCT_DELETE,
  SUPPLIER_PRODUCT_DELETE_SUCCESS,
  SUPPLIER_PRODUCT_DELETE_FAILURE,
} from "./actionType";

const initialState = {
  //SUPPLIER_PRODUCT_LIST
  supplierProductList: [],
  supplierProductListLoading: false,
  supplierProductListError: null,

  //SUPPLIER_PRODUCT_DATA
  supplierProductData: {},
  supplierProductDataLoading: false,
  supplierProductDataError: null,

  //SUPPLIER_PRODUCT_SEARCH
  supplierProductSearch: [],
  supplierProductSearchLoading: false,
  supplierProductSearchError: null,

  //SUPPLIER_PRODUCT_CREATE
  supplierProductCreate: {},
  supplierProductCreateLoading: false,
  supplierProductCreateError: null,
  //SUPPLIER_PRODUCT_UPDATE
  supplierProductUpdate: {},
  supplierProductUpdateLoading: false,
  supplierProductUpdateError: null,
  //SUPPLIER_PRODUCT_DELETE
  supplierProductDelete: {},
  supplierProductDeleteLoading: false,
  supplierProductDeleteError: null,
};

const supplierProductReducer = (state = initialState, action) => {
  switch (action.type) {
    //SUPPLIER_PRODUCT_LIST
    case SUPPLIER_PRODUCT_LIST:
      return {
        ...state,
        supplierProductListLoading: true,
        supplierProductListError: null,
      };
    case SUPPLIER_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        supplierProductList: action.payload,
        supplierProductListLoading: false,
      };
    case SUPPLIER_PRODUCT_LIST_FAILURE:
      return {
        ...state,
        supplierProductListLoading: false,
        supplierProductListError: action.payload,
      };

    //SUPPLIER_PRODUCT_DATA
    case SUPPLIER_PRODUCT_DATA:
      return {
        ...state,
        supplierProductDataLoading: true,
        supplierProductDataError: null,
      };
    case SUPPLIER_PRODUCT_DATA_SUCCESS:
      return {
        ...state,
        supplierProductData: action.payload,
        supplierProductDataLoading: false,
      };
    case SUPPLIER_PRODUCT_DATA_FAILURE:
      return {
        ...state,
        supplierProductDataLoading: false,
        supplierProductDataError: action.payload,
      };

    //SUPPLIER_PRODUCT_SEARCH
    case SUPPLIER_PRODUCT_SEARCH:
      return {
        ...state,
        supplierProductSearchLoading: true,
        supplierProductSearchError: null,
      };
    case SUPPLIER_PRODUCT_SEARCH_SUCCESS:
      return {
        ...state,
        supplierProductSearch: action.payload,
        supplierProductSearchLoading: false,
      };
    case SUPPLIER_PRODUCT_SEARCH_FAILURE:
      return {
        ...state,
        supplierProductSearchLoading: false,
        supplierProductSearchError: action.payload,
      };

    //SUPPLIER_PRODUCT_CREATE
    case SUPPLIER_PRODUCT_CREATE:
      return {
        ...state,
        supplierProductCreateLoading: true,
        supplierProductCreateError: null,
      };
    case SUPPLIER_PRODUCT_CREATE_SUCCESS:
      return {
        ...state,
        supplierProductCreate: action.payload,
        supplierProductCreateLoading: false,
      };
    case SUPPLIER_PRODUCT_CREATE_FAILURE:
      return {
        ...state,
        supplierProductCreateLoading: false,
        supplierProductCreateError: action.payload,
      };

    //SUPPLIER_PRODUCT_UPDATE
    case SUPPLIER_PRODUCT_UPDATE:
      return {
        ...state,
        supplierProductUpdateLoading: true,
        supplierProductUpdateError: null,
      };
    case SUPPLIER_PRODUCT_UPDATE_SUCCESS:
      return {
        ...state,
        supplierProductUpdate: action.payload,
        supplierProductUpdateLoading: false,
      };
    case SUPPLIER_PRODUCT_UPDATE_FAILURE:
      return {
        ...state,
        supplierProductUpdateLoading: false,
        supplierProductUpdateError: action.payload,
      };
    //SUPPLIER_PRODUCT_DELETE
    case SUPPLIER_PRODUCT_DELETE:
      return {
        ...state,
        supplierProductDeleteLoading: true,
        supplierProductDeleteError: null,
      };
    case SUPPLIER_PRODUCT_DELETE_SUCCESS:
      return {
        ...state,
        supplierProductDelete: action.payload,
        supplierProductDeleteLoading: false,
      };
    case SUPPLIER_PRODUCT_DELETE_FAILURE:
      return {
        ...state,
        supplierProductDeleteLoading: false,
        supplierProductDeleteError: action.payload,
      };
    default:
      return state;
  }
};
export default supplierProductReducer;
